import { toNumber, normalizeText } from './convertNotionalToBRL.js'

const SPREAD_STATUSES = new Set(['DEAL'])

function calculateSpreadPips(row) {
  const status = normalizeText(row.status)

  if (!SPREAD_STATUSES.has(status)) return null

  const fwd = toNumber(row.fwd)
  const fwdClient = toNumber(row.fwdclient)
  const side = normalizeText(row.side)

  if (!fwd || fwdClient == null) return null

  if (side === 'SELL' || side === 'VENDA') {
    return (fwd - fwdClient) * 10000
  }

  if (side === 'BUY' || side === 'COMPRA') {
    return (fwdClient - fwd) * 10000
  }

  return null
}

// Simple arithmetic average of side-aware pip spread across DEAL rows -
// every valid row carries equal weight, regardless of notional size.
export function calculateAverageSpreadPips(rows) {
  let sum = 0
  let count = 0

  for (const row of rows) {
    const spreadPips = calculateSpreadPips(row)

    if (spreadPips == null) continue

    sum += spreadPips
    count += 1
  }

  return count > 0
    ? sum / count
    : 0
}
